import SeoArticleLayout from '@/components/feature/SeoArticleLayout';
import { seoArticles } from '@/mocks/seo-articles';

export default function SeasonalPicksPage() {
  return <SeoArticleLayout article={seoArticles[6]} />;
}